<template>
  <VDropdown
    placement="right" :shown="isOpen" :autoHide="true"
  >
    <template #popper>
      <div class="card">
        <header class="card-header has-background-grey-lighter">
          <h4
            class="card-header-title is-size-3 has-text-black-bis
              has-text-weight-bold is-paddingless"
          >
            {{ rowField.title }}
          </h4>
          <div class="is-divider-vertical"></div>
          <span class="card-header-icon">
            <i class="icon-close is-clickable has-text-black-bis" @click="cancel()"></i>
          </span>
        </header>
        <section class="card-content is-marginless has-background-white">
          <div v-if="!items.length" class="line-height has-text-black-bis is-italic">
            No {{ rowField.title?.toLowerCase() }}
          </div>
          <div v-else class="tag-list">
            <span
              class="tag-chip"
              v-for="(item, $idx) of items" :key="$idx"
            >
              {{ item.name || item }}
            </span>
          </div>
        </section>
      </div>
    </template>
  </VDropdown>
  <div class="is-flex is-justify-content-center is-align-items-center">
    <button
      class="button mr-0 has-text-weight-bold"
      :class="items.length ? 'has-background-black-bis has-text-white' : ''"
      @click="openModal"
    >
      <span class="is-size-3">{{ items.length }}</span>
    </button>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, computed } from 'vue';
import { get } from 'lodash';

export default defineComponent({
  name: 'CategoryCountIcon',
  props: ['value', 'rowField', 'rowData', 'rowIndex'],
  setup(props) {
    const state = reactive({
      isOpen: false,
    });

    const items = computed(() => {
      const val = get(props.rowData, props.rowField.prop, []);
      return Array.isArray(val) ? val : [];
    });

    const openModal = () => {
      state.isOpen = !state.isOpen;
    };

    const cancel = () => {
      state.isOpen = !state.isOpen;
    };

    return {
      ...toRefs(state),
      items,
      openModal,
      cancel,
    };
  },
});
</script>

<style scoped>
.is-divider {
  margin: 8px 0 !important;
}
.button.mr-0:hover i {
  color: white !important;
}
.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.tag-chip {
  display: inline-block;
  padding: 2px 5px;
  border-radius: 4px;
  background-color: #363636;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
}
</style>